 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		24: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"2580449cbdca25622be15cc54f6382e29ccbdcd7","1":"100c9062","2":"b01f64f3","3":"b637e9a5","4":"fdb1769b1c45d420c68378749f56ff456fccd880","5":"bbf0ae3752f5f7e6f392b0b9f086e8067312ab6a","6":"57ac46d285b416f4fafcc5aa8e1051b5e1db19f1","7":"a09686f1","8":"b07aaa4f","9":"55bfca2627b7a7ff0389fc6d4452dbae3f006217","10":"4a754ec80b178711dc26cb30cefd4fcf6c941ecb","11":"05d954cf","12":"476edd5e68b7975907972b0ccb47d07c6996830f","13":"c929556b142d98b066b8861212010a9406a162c3","14":"e8cbb670aba452384e47764d95ca5be58beb1144","15":"framework","16":"5a6f9aa80bec0d55a61c485bbb4a741261969b63","17":"888c22908c6a1b8476a48b8f624821ab43919eb0","18":"component---src-pages-merchant-manageusers-create-js","19":"component---src-pages-merchant-manageusers-dashboard-js","20":"component---src-pages-merchant-manageusers-edit-js","21":"component---src-pages-merchant-statements-graphs-js","22":"component---src-pages-points-checkout-index-js","23":"component---src-pages-token-checkout-index-js","29":"component---src-pages-about-au-js","30":"component---src-pages-about-index-js","31":"component---src-pages-about-nz-js","32":"component---src-pages-checkout-js","33":"component---src-pages-embed-shopify-dashboard-js","34":"component---src-pages-error-js","35":"component---src-pages-index-js","36":"component---src-pages-info-js","37":"component---src-pages-merchant-analytics-index-js","38":"component---src-pages-merchant-home-index-js","39":"component---src-pages-merchant-index-js","40":"component---src-pages-merchant-login-callback-js","41":"component---src-pages-merchant-login-index-js","42":"component---src-pages-merchant-logout-js","43":"component---src-pages-merchant-orders-create-js","44":"component---src-pages-merchant-orders-dashboard-js","45":"component---src-pages-merchant-orders-review-js","46":"component---src-pages-merchant-orders-summary-js","47":"component---src-pages-merchant-orders-transactiondashboard-js","48":"component---src-pages-merchant-pos-initiate-js","49":"component---src-pages-merchant-pos-orders-summary-js","50":"component---src-pages-merchant-promotions-index-js","51":"component---src-pages-merchant-reports-index-js","52":"component---src-pages-merchant-selectmerchant-index-js","53":"component---src-pages-merchant-statements-settlementsummary-js","54":"component---src-pages-merchant-trainingguides-index-js","55":"component---src-pages-outcome-js","56":"component---src-pages-payment-complete-js","57":"component---src-pages-playground-checkout-js","58":"component---src-pages-playground-widget-js","59":"component---src-pages-playground-widget-testing-js","60":"component---src-pages-points-index-js","61":"component---src-pages-points-login-callback-js","62":"component---src-pages-points-login-index-js","63":"component---src-pages-purchase-initiate-js","64":"component---src-pages-rewards-index-js","65":"component---src-pages-rewards-link-index-js","66":"component---src-pages-rewards-login-callback-js","67":"component---src-pages-rewards-login-index-js","68":"component---src-pages-shopify-about-js","69":"component---src-pages-shopify-auth-js","70":"component---src-pages-shopify-install-js","71":"component---src-pages-shopify-payment-index-js","72":"component---src-pages-shopify-payment-outcome-js","73":"component---src-pages-shopify-payment-settings-js","74":"component---src-pages-token-index-js","75":"component---src-pages-token-login-callback-js","76":"component---src-pages-token-login-index-js","77":"component---src-pages-token-logout-js","78":"component---src-pages-wallet-checkout-index-js","79":"component---src-pages-wallet-index-js","80":"component---src-pages-wallet-login-callback-js","81":"component---src-pages-wallet-login-index-js","82":"component---src-pages-wallet-logout-js"}[chunkId]||chunkId) + "-" + {"0":"65e22599917d4e2cf9a3","1":"c091cbacc5bda877d9a4","2":"ea308e89d5bc7ded764d","3":"7fd41b8cceebac90b3b5","4":"99d11a13c0ae425d9ee7","5":"c3316a89e547eef517f7","6":"b8864f4063b37721d1eb","7":"c28159cfc4e1bff2af4b","8":"380a0bf1b45786717cb9","9":"3eb6da5dba8f6fe8bb97","10":"188e9be5f7db1b381923","11":"245a485420726d245cd9","12":"9e6ce524b5d7c6e7b0af","13":"9c9ac9c2298b618c8947","14":"61a3c2055adfb356d9ba","15":"b3e4be764f315c02d1fb","16":"ce27f97038c96b5855e8","17":"142e5b3f52ae610ccdd8","18":"b9eff73a55159f96c3d3","19":"aaaaf57020b07bfb785a","20":"90bf58cefb44b2115005","21":"964ceda35e1b2f6fe9bb","22":"c5027ee8b6604c2471aa","23":"dcf1e29450be02cfce51","29":"c684d35eb0bbaafd1ab6","30":"8cff63676424d14c2f72","31":"456a28bf079404c63820","32":"d98ef84d61a8c3f20fb2","33":"b4f82b3d689614d0bbfe","34":"e8804d26f53d2dce14a4","35":"da568c2a74043a6447a3","36":"3b822db2136864a79f08","37":"2fc07147c8ee387e7eb1","38":"68a966bf00f41b8774ef","39":"0656eb1c5bab57424dfe","40":"35d1d3f2fd518c78711f","41":"b2df05f5740bcec5ffa4","42":"09761238a729fac3b76d","43":"565e323e4e9db6db815f","44":"655bc976819cfa0d7374","45":"543e3c0d139505d44d8a","46":"3e9b66071822fc8c92d1","47":"83ccfa256c523128ef90","48":"25acc1e45c7b8b744eab","49":"0b0e28a68f64b30a2f29","50":"75de41cde55f1c9c3024","51":"11a6226032db1156027c","52":"c59f8ef94bc2be9a2a67","53":"82b9eee5a8a07a274d8b","54":"0545b6bfefd40b730ef9","55":"beeba20f61852dfd5714","56":"33466b21dd20a461b855","57":"c9d2f512b546dd5290e9","58":"25ea0667310e03d4ff48","59":"11f3c5e9fe17e0034866","60":"023f3d2e0b1a568204df","61":"05bd61b554e474f955f3","62":"ecbd099315cbc57db2ed","63":"64d039ea10352dbc1644","64":"5e7a385ab259c8c23cc6","65":"834d5d3db8695954afdb","66":"2675f736de19236e2fdd","67":"bb6e5fc168d5fe3e52b5","68":"0d340afabd790c11cb98","69":"d5148726125d07b0ec43","70":"0561d2fbc2da7ef807ef","71":"15da7da31ae7a2f7eff0","72":"e669277107440a4c85a8","73":"5017d1ddca638aa767d3","74":"b58c74046ae762f3873e","75":"dd2a4ad6fb1f2325a2c7","76":"b18c5086a074c339c673","77":"8185e1bb7d2ac12a3b61","78":"6886fdc93b62e008b445","79":"e6bd58b1139e8dce20a9","80":"74a1564b33e3da84e014","81":"40921163154aa243c03b","82":"cfef0241a24a97682e15"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
